'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    margin-top: ', 'px;\n    margin-right: ', 'px;\n    margin-bottom: ', 'px;\n    margin-left: ', 'px;\n'], ['\n    width: 100%;\n    margin-top: ', 'px;\n    margin-right: ', 'px;\n    margin-bottom: ', 'px;\n    margin-left: ', 'px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recharts = require('recharts');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _colors = require('../../constants/colors');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('../../constants/sizes');

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MarginWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
    var top = _ref.top;
    return (0, _getSize2.default)(top);
}, function (_ref2) {
    var right = _ref2.right;
    return (0, _getSize2.default)(right);
}, function (_ref3) {
    var bottom = _ref3.bottom;
    return (0, _getSize2.default)(bottom);
}, function (_ref4) {
    var left = _ref4.left;
    return (0, _getSize2.default)(left);
});

// Default formatter that doesn't require intl
var defaultValueFormatter = function defaultValueFormatter(value, mode) {
    var numValue = Number(value);
    switch (mode) {
        case 'currency':
            if (numValue >= 1e6) {
                return (numValue / 1e6).toFixed(2) + 'M';
            } else if (numValue >= 1e3) {
                return Math.round(numValue / 1e3) + 'K';
            }
            return '' + Math.round(numValue);
        case 'percentage':
            return numValue.toFixed(0) + '%';
        case 'number':
            return Math.round(numValue).toString();
        default:
            return Math.round(numValue).toString();
    }
};

var CustomXAxisTick = function CustomXAxisTick(_ref5) {
    var x = _ref5.x,
        y = _ref5.y,
        payload = _ref5.payload,
        legendTextColor = _ref5.legendTextColor,
        tickFontSize = _ref5.tickFontSize,
        fontFamily = _ref5.fontFamily;

    return _react2.default.createElement(
        'g',
        { transform: 'translate(' + x + ',' + y + ')' },
        _react2.default.createElement(
            'text',
            {
                x: 0,
                y: 0,
                dy: 5,
                dx: 10,
                fill: legendTextColor,
                fontSize: tickFontSize,
                fontFamily: fontFamily,
                textAnchor: 'end',
                transform: 'rotate(-45)'
            },
            payload.value
        )
    );
};

var CustomYAxisTick = function CustomYAxisTick(_ref6) {
    var x = _ref6.x,
        y = _ref6.y,
        payload = _ref6.payload,
        tickFormatter = _ref6.tickFormatter,
        legendTextColor = _ref6.legendTextColor,
        tickFontSize = _ref6.tickFontSize,
        fontFamily = _ref6.fontFamily,
        mode = _ref6.mode;

    var formattedValue = tickFormatter(payload.value, mode);

    return _react2.default.createElement(
        'g',
        { transform: 'translate(' + x + ',' + y + ')' },
        _react2.default.createElement(
            'text',
            {
                x: 0,
                y: 0,
                dy: 4,
                fill: legendTextColor,
                fontSize: tickFontSize,
                fontFamily: fontFamily,
                textAnchor: 'end'
            },
            formattedValue
        )
    );
};

var DisplayChartBase = function DisplayChartBase(_ref7) {
    var _ref7$data = _ref7.data,
        data = _ref7$data === undefined ? [] : _ref7$data,
        _ref7$lineColor = _ref7.lineColor,
        lineColor = _ref7$lineColor === undefined ? _colors.Colors.Success : _ref7$lineColor,
        _ref7$gridColor = _ref7.gridColor,
        gridColor = _ref7$gridColor === undefined ? _colors.Colors.StrokeMedium : _ref7$gridColor,
        _ref7$axisColor = _ref7.axisColor,
        axisColor = _ref7$axisColor === undefined ? _colors.Colors.StrokeDark : _ref7$axisColor,
        _ref7$backgroundColor = _ref7.backgroundColor,
        backgroundColor = _ref7$backgroundColor === undefined ? 'white' : _ref7$backgroundColor,
        _ref7$legendTextColor = _ref7.legendTextColor,
        legendTextColor = _ref7$legendTextColor === undefined ? _colors.Colors.PrimaryText : _ref7$legendTextColor,
        _ref7$fontFamily = _ref7.fontFamily,
        fontFamily = _ref7$fontFamily === undefined ? '"Poppins", sans-serif' : _ref7$fontFamily,
        _ref7$mode = _ref7.mode,
        mode = _ref7$mode === undefined ? 'number' : _ref7$mode,
        _ref7$top = _ref7.top,
        top = _ref7$top === undefined ? _sizes.Sizes.none : _ref7$top,
        _ref7$right = _ref7.right,
        right = _ref7$right === undefined ? _sizes.Sizes.none : _ref7$right,
        _ref7$bottom = _ref7.bottom,
        bottom = _ref7$bottom === undefined ? _sizes.Sizes.none : _ref7$bottom,
        _ref7$left = _ref7.left,
        left = _ref7$left === undefined ? _sizes.Sizes.none : _ref7$left,
        intl = _ref7.intl;

    var isMobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());

    // Create formatter function with intl if available
    var yAxisValueFormatter = function yAxisValueFormatter(value, mode) {
        if (!intl) return defaultValueFormatter(value, mode);

        var numValue = Number(value);
        try {
            switch (mode) {
                case 'currency':
                    if (numValue >= 1e6) {
                        var millionAbbr = intl.formatMessage({ id: 'DisplayChart.abbreviations.million' });
                        return '' + (numValue / 1e6).toFixed(2) + millionAbbr;
                    } else if (numValue >= 1e3) {
                        var thousandAbbr = intl.formatMessage({ id: 'DisplayChart.abbreviations.thousand' });
                        return '' + Math.round(numValue / 1e3) + thousandAbbr;
                    }
                    return '' + Math.round(numValue);
                case 'percentage':
                    var percentSymbol = intl.formatMessage({ id: 'DisplayChart.symbols.percentage' });
                    return '' + numValue.toFixed(0) + percentSymbol;
                case 'number':
                    return Math.round(numValue).toString();
                default:
                    return Math.round(numValue).toString();
            }
        } catch (error) {
            // Fallback to default formatter if any error occurs
            console.error('Error in yAxisValueFormatter:', error);
            return defaultValueFormatter(value, mode);
        }
    };

    var axisPadding = isMobile ? 5 : 20;
    var lineStrokeWidth = isMobile ? 5 : 10;
    var tickFontSize = isMobile ? 12 : 15;
    var yTickMargin = isMobile ? 5 : 15;
    var xTickMargin = isMobile ? 10 : 25;
    var yAxisWidth = isMobile ? 50 : 100;

    if (data.length === 0) return null;

    var sortedData = [].concat(_toConsumableArray(data)).sort(function (a, b) {
        return new Date(a.label) - new Date(b.label);
    });
    var values = sortedData.map(function (item) {
        return Number(item.value);
    });
    var dataMin = Math.min.apply(Math, _toConsumableArray(values));
    var dataMax = Math.max.apply(Math, _toConsumableArray(values));
    var dataRange = dataMax - dataMin;

    var padding = dataRange * 0.5;
    var minValue = Math.max(0, dataMin - padding);
    var maxValue = dataMax + padding;

    var calculateDynamicInterval = function calculateDynamicInterval(minValue, maxValue) {
        var range = maxValue - minValue;
        var roughInterval = range / 6;
        var magnitude = Math.pow(10, Math.floor(Math.log10(roughInterval)));
        var normalizedInterval = roughInterval / magnitude;

        var interval = void 0;
        if (normalizedInterval < 1.5) {
            interval = 1 * magnitude;
        } else if (normalizedInterval < 3) {
            interval = 2 * magnitude;
        } else if (normalizedInterval < 7.5) {
            interval = 5 * magnitude;
        } else {
            interval = 10 * magnitude;
        }

        return interval;
    };

    var interval = calculateDynamicInterval(minValue, maxValue);
    var startValue = Math.floor(minValue / interval) * interval;
    var numSteps = Math.ceil((maxValue - startValue) / interval);
    var ticks = Array.from({ length: numSteps + 1 }, function (_, i) {
        return startValue + i * interval;
    });

    (0, _react.useEffect)(function () {
        var timer = setTimeout(function () {
            var svg = document.getElementsByClassName('recharts-surface');
            if (svg.length > 0) {
                svg[0].style.setProperty('overflow', 'visible', 'important');
            }
        }, 100);

        return function () {
            return clearTimeout(timer);
        };
    }, []);

    return _react2.default.createElement(
        MarginWrapper,
        {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        },
        _react2.default.createElement(
            _recharts.ResponsiveContainer,
            {
                width: '100%',
                aspect: 2 / 1
            },
            _react2.default.createElement(
                _recharts.LineChart,
                {
                    data: sortedData
                },
                _react2.default.createElement(_recharts.CartesianGrid, {
                    strokeDasharray: '3 3',
                    stroke: gridColor,
                    fill: backgroundColor
                }),
                _react2.default.createElement(_recharts.XAxis, {
                    dataKey: 'label',
                    stroke: axisColor,
                    tick: _react2.default.createElement(CustomXAxisTick, {
                        legendTextColor: legendTextColor,
                        tickFontSize: tickFontSize,
                        fontFamily: fontFamily
                    }),
                    tickMargin: xTickMargin,
                    padding: { left: axisPadding, right: axisPadding },
                    allowDataOverflow: false
                }),
                _react2.default.createElement(_recharts.YAxis, {
                    stroke: axisColor,
                    tick: _react2.default.createElement(CustomYAxisTick, {
                        legendTextColor: legendTextColor,
                        tickFontSize: tickFontSize,
                        fontFamily: fontFamily,
                        tickFormatter: yAxisValueFormatter,
                        mode: mode
                    }),
                    tickMargin: yTickMargin,
                    tickFormatter: yAxisValueFormatter,
                    domain: [minValue, maxValue],
                    ticks: ticks,
                    width: yAxisWidth,
                    padding: { top: axisPadding, bottom: axisPadding },
                    interval: 0
                }),
                _react2.default.createElement(_recharts.Tooltip, {
                    formatter: function formatter(value) {
                        return yAxisValueFormatter(value, mode);
                    },
                    wrapperStyle: { backgroundColor: backgroundColor, fontFamily: fontFamily }
                }),
                _react2.default.createElement(_recharts.Line, {
                    type: 'monotone',
                    dataKey: 'value',
                    stroke: lineColor,
                    strokeWidth: lineStrokeWidth,
                    dot: {
                        fill: backgroundColor,
                        r: lineStrokeWidth,
                        stroke: lineColor,
                        strokeWidth: lineStrokeWidth / 2
                    },
                    activeDot: {
                        fill: backgroundColor,
                        r: lineStrokeWidth,
                        stroke: _colors.Colors.Primary,
                        strokeWidth: lineStrokeWidth / 2
                    }
                }),
                data.length > 0 && _react2.default.createElement(_recharts.ReferenceLine, { x: sortedData[sortedData.length - 1].label,
                    stroke: _colors.Colors.Primary,
                    strokeWidth: 2
                })
            )
        )
    );
};

DisplayChartBase.propTypes = {
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.number.isRequired
    })).isRequired,
    lineColor: _propTypes2.default.string,
    gridColor: _propTypes2.default.string,
    axisColor: _propTypes2.default.string,
    backgroundColor: _propTypes2.default.string,
    legendTextColor: _propTypes2.default.string,
    fontFamily: _propTypes2.default.string,
    mode: _propTypes2.default.oneOf(['currency', 'percentage', 'number']),
    top: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    right: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    bottom: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    left: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    intl: _propTypes2.default.object
};

CustomXAxisTick.propTypes = {
    x: _propTypes2.default.number,
    y: _propTypes2.default.number,
    payload: _propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired
    }),
    legendTextColor: _propTypes2.default.string,
    tickFontSize: _propTypes2.default.number,
    fontFamily: _propTypes2.default.string
};

CustomYAxisTick.propTypes = {
    x: _propTypes2.default.number,
    y: _propTypes2.default.number,
    payload: _propTypes2.default.shape({
        value: _propTypes2.default.number.isRequired
    }),
    tickFormatter: _propTypes2.default.func.isRequired,
    legendTextColor: _propTypes2.default.string,
    tickFontSize: _propTypes2.default.number,
    fontFamily: _propTypes2.default.string,
    mode: _propTypes2.default.string
};

var DisplayChart = (0, _reactIntl.injectIntl)(DisplayChartBase);
exports.default = DisplayChart;